import { createSelector } from 'reselect';

import { getConfigurator } from './getConfigurator';

export const getBuilder = createSelector(
  getConfigurator,
  configurator => configurator.builder
);
